<script lang="ts">
	import { Skeleton } from "#lib/web-ui/ui/skeleton/index.js";
</script>

<div class="flex h-full flex-col overflow-hidden rounded border shadow-sm">
	<Skeleton class="h-40 w-full rounded-none" />
	<div class="space-y-2 p-3">
		<Skeleton class="h-6 w-2/3" />
		<Skeleton class="h-4 w-full" />
		<Skeleton class="h-4 w-1/2" />
		<div class="flex gap-3">
			<Skeleton class="h-3.5 w-14" />
			<Skeleton class="h-3.5 w-14" />
			<Skeleton class="h-3.5 w-20" />
		</div>
	</div>
</div>
